import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ShiftWorkingDayService } from '../proxy/controlling/controllers/shift-working-day.service';
import { VendorService } from '../proxy/controlling/controllers/vendor.service';

FieldBuilder.setNamespace('Controlling');

export const VENDORSHIFTWORKINGDAY_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey(
    'shiftWorkingDayId',
    'Entity.VendorShiftWorkingDay.ShiftWorkingDay',
    ShiftWorkingDayService
  )
    .required()
    .displayFromNested('shiftWorkingDay.name')
    .sortBy('shiftWorkingDay.name')
    .build(),
  FieldBuilder.foreignKey(
    'vendorId',
    'Entity.Vendor',
    VendorService
  )
    .required()
    .displayFromNested('vendor.name')
    .sortBy('vendor.name')
    .build(),
];

export const VENDORSHIFTWORKINGDAY_CONFIG = {
  entityName: 'VendorShiftWorkingDay',
  localizationKey: 'Controlling::Entity.VendorShiftWorkingDay',
  fields: VENDORSHIFTWORKINGDAY_FIELDS,
  permission: 'Harvest.VendorShiftWorkingDays',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Harvest + MENU_NAME_SUFFIX,
};
